<template>
  <div class="invoiceWrap">
    <div class="invoiceMain">
      <div class="flex-row jcsb">
        <div>
          <template v-if="invoiceDetail.billFrom">
            <img :src="invoiceDetail.billFrom.companyLogoUrl?.url" alt="" class="hg60" v-if="invoiceDetail.billFrom.companyLogoUrl?.url" />
            <span class="fs26 invoiceBlue" v-else>{{ invoiceDetail.billFrom.abbr }}</span>
          </template>
        </div>
        <div class="fxRow hg60">
          <!-- 普通发票 -->
          <p class="fs32 fwb invoiceBlue" v-if="invoiceDetail.invoiceType == 1">
            {{ isGstInvoice ? "Tax Invoice" : "Invoice" }}
            <span class="fs16 smallDesc">{{ isGstInvoice ? languageMap.taxInvoice : languageMap.invoice }}</span>
          </p>
          <!-- 退款发票 -->
          <p class="fs32 fwb red" v-if="invoiceDetail.invoiceType == 2">
            {{ isGstInvoice ? "Credit Tax Invoice" : "Credit Invoice" }}
            <span class="fs16 smallDesc">{{ isGstInvoice ? languageMap.creditTaxInvoice : languageMap.creditInvoice }}</span>
          </p>
        </div>
      </div>
      <div class="fdr jcsb pt10">
        <div class="addressWrap">
          <p class="fs14 fwb">{{ invoiceDetail.billFrom?.name }}</p>
          <p class="fs14">Registration No: {{ invoiceDetail.billFrom?.registrationNumber }}</p>
          <p class="fs14">{{ invoiceDetail.billFrom?.address }}</p>
          <p class="fs14">
            {{ invoiceDetail.billFrom?.country }},
            {{ invoiceDetail.billFrom?.postalCode }}
          </p>
        </div>
        <div class="pl20 basicWrap">
          <p>
            <label>
              DATE
              <span class="smallDesc">{{ languageMap.date }}</span>
              :
            </label>
            <span>{{ invoiceDetail.issuedDate }}</span>
          </p>
          <p>
            <label v-if="invoiceDetail.invoiceType == 1">
              Invoice #
              <span class="smallDesc">{{ languageMap.invoiceNumber }}</span>
              :
            </label>
            <label v-if="invoiceDetail.invoiceType == 2">
              Credit Invoice #
              <span class="smallDesc">{{ languageMap.creditInvoiceNumber }}</span>
              :
            </label>
            <span>{{ invoiceDetail.invoiceNumber }}</span>
          </p>
          <p>
            <label>
              Transaction No
              <span class="smallDesc">{{ languageMap.transactionNo }}</span>
              :
            </label>
            <span>{{ invoiceDetail.businessNo }}</span>
          </p>
          <p v-if="invoiceDetail.invoiceType == 1">
            <label>
              Due Date
              <span class="smallDesc">{{ languageMap.dueDate }}</span>
              :
            </label>
            <span>{{ invoiceDetail.dueDate }}</span>
          </p>
        </div>
      </div>
      <!-- to -->
      <div class="pt10 toWrap">
        <p class="toTh">
          To
          <span class="white smallDesc">{{ languageMap.to }}</span>
          :
        </p>
        <div class="fs12 pt10">
          <p class="lh22">
            <label class="fwb mr4">
              Name
              <span class="smallDesc">{{ languageMap.name }}</span>
              :
            </label>
            <span>{{ invoiceDetail.billTo?.name }}</span>
          </p>
          <p class="lh22">
            <label class="fwb mr4">
              Address
              <span class="smallDesc">{{ languageMap.address }}</span>
              :
            </label>
            <span>{{ invoiceDetail.billTo?.address }}</span>
          </p>
          <p class="lh22">
            <label class="fwb mr4">
              Country
              <span class="smallDesc">{{ languageMap.country }}</span>
              :
            </label>
            <span>{{ invoiceDetail.billTo?.country }}</span>
          </p>
          <p class="lh22">
            <label class="fwb mr4">
              Code
              <span class="smallDesc">{{ languageMap.code }}</span>
              :
            </label>
            <span>{{ invoiceDetail.billTo?.postalCode }}</span>
          </p>
          <p class="lh22 mt2">
            <label class="fwb mr4">
              Attention
              <span class="smallDesc">{{ languageMap.attention }}</span>
              :
            </label>
            <span>Accounts Department</span>
          </p>
        </div>
      </div>
      <!-- description -->
      <div class="pt10 descriptionWrap">
        <div class="fdr tableHead">
          <p class="wd740">
            DESCRIPTION
            <span class="white smallDesc">{{ languageMap.description }}</span>
          </p>
          <p class="wd180">
            AMOUNT
            <span class="mr4 white smallDesc">{{ languageMap.amount }}</span>
            <span class="white">{{ currencyToSymbol(invoiceDetail.billingCurrency, true) }}</span>
          </p>
        </div>
        <div class="tableBody">
          <!-- 插槽 -->
          <slot name="descriptionAndAmount"></slot>
        </div>
      </div>

      <!-- Remarks -->
      <div class="fdr pt10">
        <div class="wd300 remarksWrap">
          <p class="remarksHead">
            Remarks
            <span class="white smallDesc">{{ languageMap.remarks }}</span>
          </p>
          <div class="wdb100 pt6">
            <p class="lh22 fs12">
              <span class="mr4">Service Type:</span>
              <span>{{ getBusinessType }}</span>
            </p>
            <template v-if="invoiceDetail.remark">
              <p class="lh22 fs12 preLine">
                {{ invoiceDetail.remark }}
              </p>
            </template>
          </div>
        </div>
        <div>
          <div class="totalDueWrap">
            <p class="leftTotal">
              Total Due
              <template v-if="taxTypeStr">({{ taxTypeStr }} excluded)</template>
              <span class="smallDesc">
                {{ languageFormat(languageMap.totalDue, { excludedStr: taxTypeStr ? languageFormat(languageMap.totalDueExcluded, { taxTypeStr: taxTypeStr }) : "" }) }}
              </span>
            </p>
            <p class="rightSubtotal">{{ priceCurrencyFormat(invoiceDetail.subtotalAmount, invoiceDetail.billingCurrency) }}</p>
          </div>
          <template v-if="invoiceDetail?.taxInfos?.length > 0">
            <div class="taxWrap">
              <div class="fs12 fdr lh16 pt4 pb5">
                <p class="pl10 pr10">
                  Of which,
                  <span class="smallDesc">{{ languageMap.ofWhich }}</span>
                </p>
              </div>
              <div class="taxInfoWrap" v-for="(item, index) in invoiceDetail.taxInfos" :key="`taxInfos-${index}`">
                <div class="taxInfoItem">
                  <p class="leftType">
                    Taxable ({{ item.taxType }} excluded)
                    <span class="smallDesc">{{ languageFormat(languageMap.taxableExcluded, { taxType: item.taxType }) }}</span>
                  </p>
                  <p class="rightValue">{{ priceCurrencyFormat(invoiceDetail.taxableAmount, invoiceDetail.billingCurrency) }}</p>
                </div>
                <div class="taxInfoItem">
                  <p class="leftType">
                    Tax rate ({{ item.taxType }})
                    <span class="smallDesc">{{ languageFormat(languageMap.taxRate, { taxType: item.taxType }) }}</span>
                  </p>
                  <p class="rightValue">{{ item.taxRate | percentage }}</p>
                </div>
                <div class="taxInfoItem">
                  <p class="leftType">
                    Tax due ({{ item.taxType }})
                    <span class="smallDesc">{{ languageFormat(languageMap.taxDue, { taxType: item.taxType }) }}</span>
                  </p>
                  <p class="rightValue">{{ priceCurrencyFormat(item.taxAmount, invoiceDetail.billingCurrency) }}</p>
                </div>
              </div>
            </div>
            <div class="totalDueWrap">
              <p class="leftTotal">
                Total Due (tax included)
                <span class="smallDesc">{{ languageMap.totalDueIncluded }}</span>
              </p>
              <p class="rightSubtotal">{{ priceCurrencyFormat(invoiceDetail.totalAmount, invoiceDetail.billingCurrency) }}</p>
            </div>
          </template>
        </div>
      </div>

      <!-- 关联的原订单列表，Quotation (V) 并且 退款发票(invoiceType == 2)才显示 -->
      <template v-if="invoiceDetail.businessType == 'ADJUSTMENT' && invoiceDetail.invoiceType == 2">
        <div class="originalInvoiceWrap" v-if="invoiceDetail.refInvoiceList?.length > 0">
          <table class="originalInvoiceTable">
            <thead>
              <tr>
                <th>
                  Original Invoice No.
                  <span class="smallDesc">{{ languageMap.originalInvoiceNo }}</span>
                </th>
                <th>
                  Original Invoice Date
                  <span class="smallDesc">{{ languageMap.originalInvoiceDate }}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in invoiceDetail.refInvoiceList" :key="`originalInvoice-${index}`">
                <td>{{ item.invoiceNumber }}</td>
                <td>{{ item.createTime }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>

      <!-- 普通发票(invoiceType == 1)才显示 -->
      <div class="payWrap" v-if="invoiceDetail.invoiceType == 1">
        <div>
          <p class="fw600">
            Payment Instruction
            <span class="smallDesc">{{ languageMap.paymentInstruction }}</span>
            :
          </p>
          <p class="pt2 pb2">
            Please make cheque payable to {{ invoiceDetail.billFrom?.name }}. Or payment can be remitted direct into below account of {{ invoiceDetail.billFrom?.name }}.
          </p>
          <p class="pb2">
            <span class="fs12 smallDesc">{{ languageFormat(languageMap.pleaseMakeCheque, { billFromName: invoiceDetail.billFrom?.name }) }}</span>
          </p>
        </div>
        <template v-if="invoiceDetail.bankAccountList?.length > 0">
          <div class="bankAccountWrap">
            <div class="bankAccountItem" v-for="item in invoiceDetail.bankAccountList" :key="`bankAccountInfo-${item.id}`">
              <p v-if="item.bankName">
                <label>Bank Name:</label>
                <span>{{ item.bankName }}</span>
              </p>
              <p v-if="item.bankAddress">
                <label>Bank Address:</label>
                <span>{{ item.bankAddress }}</span>
              </p>
              <p v-if="item.swiftCode">
                <label>Swift Code:</label>
                <span>{{ item.swiftCode }}</span>
              </p>
              <p v-if="item.accountName">
                <label>Account Name:</label>
                <span>{{ item.accountName }}</span>
              </p>
              <p v-if="item.addressOfBeneficiary">
                <label>Address of Beneficiary:</label>
                <span>{{ item.addressOfBeneficiary }}</span>
              </p>
              <p v-if="item.accountNumber">
                <label>Account Number:</label>
                <span>{{ item.accountNumber }}</span>
              </p>
            </div>
          </div>
          <div class="qrcodeWrap">
            <div class="qrcodeItem" v-for="(item, index) in bankAccountQrcodeList" :key="`bankAccountQrcode-${index}`">
              <img :src="item.url" alt="" />
              <p>{{ item.remark }}</p>
            </div>
          </div>
        </template>
      </div>

      <p class="pt16 fs12 fwb">
        This is an electronically generated receipt. No signature is required.
        <span class="smallDesc">{{ languageMap.thisIsAnElectronically }}</span>
      </p>
    </div>
  </div>
</template>

<script>
import filtersMixin from "@/mixins/filtersMixin";
import formatMixin from "@/mixins/formatMixin";
import { mapGetters } from "vuex";
export default {
  name: "Invoice",
  mixins: [filtersMixin, formatMixin],
  props: {
    invoiceDetail: {
      type: Object,
      default: () => {},
    },
    languageMap: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("constant", ["getAllBusinessTypeList"]),
    // 获取银行账户中的qrcode
    bankAccountQrcodeList() {
      const bankAccountList = this.invoiceDetail.bankAccountList || [];
      const qrcodeInfoList = bankAccountList.map(item => item.qrcodeInfoList || []);
      // 将二维数组拉平一层
      const result = qrcodeInfoList.flat();
      return result;
    },
    // 获取服务类型
    getBusinessType() {
      const businessType = this.invoiceDetail.businessType;
      if (businessType) {
        const data = this.getAllBusinessTypeList.find(item => item.value == businessType);
        return data.en || "";
      } else {
        return "";
      }
    },
    // 获取税率类型，并拼接成字符串
    taxTypeStr() {
      const taxInfos = this.invoiceDetail?.taxInfos || [];
      const taxTypeList = taxInfos.map(item => item.taxType || null).filter(ele => ele != null);
      return taxTypeList.join(" & ");
    },
    // 是否为 GST 发票（taxInfos 中存在含 GST 的税种，忽略大小写）
    isGstInvoice() {
      const taxInfos = this.invoiceDetail?.taxInfos || [];
      return taxInfos.some(item => String(item.taxType || "").toUpperCase().includes("GST"));
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.smallDesc {
  font-size: 10px;
  color: #555;
  font-weight: normal !important;
  font-style: italic !important;
}

.invoiceWrap {
  padding-top: 14px;
  padding-bottom: 14px;

  p {
    box-sizing: border-box;
  }

  .invoiceMain {
    width: 960px;
    margin: 0 auto;
    font-size: 12px;
    color: #000;
    padding: 18px;
    background: rgb(249, 249, 249);

    .invoiceBlue {
      color: #8394c9;

      span {
        color: #8394c9 !important;
      }
    }

    .addressWrap {
      max-width: 494px;
    }

    .basicWrap {
      p {
        label {
          display: inline-block;
          font-weight: bold;
          width: 210px;
          text-align: right;
          padding-right: 10px;
        }

        span {
          display: inline-block;
          max-width: 400px;
        }
      }
    }

    .toWrap {
      .toTh {
        width: 300px;
        height: 26px;
        line-height: 26px;
        color: #fff;
        font-size: 12px;
        font-weight: 700;
        background: #3b4e87;
        text-indent: 10px;
      }
    }

    .descriptionWrap {
      .tableHead {
        width: 100%;
        height: 26px;
        line-height: 26px;
        background: #3b4e87;

        p {
          height: 26px;
          line-height: 26px;
          color: #fff;
          font-size: 12px;
          font-weight: bold;
          text-align: center;
        }
      }

      .tableBody {
        padding-top: 8px;

        .mainTitle {
          font-size: 14px;
          font-weight: bold;
          line-height: 26px;
        }

        .rowItem {
          padding-top: 6px;

          .secondTitle {
            font-size: 12px;
            font-weight: bold;
            line-height: 26px;
          }

          .feeItem {
            display: flex;
            flex-direction: row;
            font-size: 12px;
            line-height: 16px;
            padding: 4px 0;

            .leftDesc {
              width: 740px;
              padding-right: 10px;
            }

            .rightAmount {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 180px;
            }
          }

          .feeItem:nth-child(even) {
            background: #fff;
          }
        }

        .rowItem:first-of-type {
          padding-top: 0px;
        }
      }
    }

    .remarksWrap {
      background: #fff;
      padding-bottom: 10px;

      .remarksHead {
        width: 100%;
        height: 26px;
        line-height: 26px;
        background: #3b4e87;
        color: #fff;
        font-size: 12px;
        font-weight: bold;
        text-indent: 10px;
      }
    }

    .totalDueWrap {
      display: flex;
      flex-direction: row;
      font-size: 12px;
      line-height: 16px;
      padding: 3px 0 4px;
      font-weight: bold;
      border: 1px solid #3b4e87;
      background: #fff;

      .leftTotal {
        text-align: left;
        padding: 0px 10px;
        width: 440px;
      }

      .rightSubtotal {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 180px;
      }
    }

    .taxWrap {
      background-color: #ededed;
      border-left: 1px solid #3b4e87;
      border-right: 1px solid #3b4e87;
    }

    .taxInfoWrap {
      margin: 0 1px;

      .taxInfoItem {
        display: flex;
        flex-direction: row;
        font-size: 12px;
        line-height: 16px;
        padding: 4px 0;
        border-top: 1px solid #fff;

        .leftType {
          text-align: left;
          padding: 0 16px;
          width: 440px;
        }

        .rightValue {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 180px;
        }
      }
    }

    .originalInvoiceWrap {
      padding-top: 20px;

      .originalInvoiceTable {
        width: 100%;
        border-collapse: collapse;

        th,
        td {
          height: 20px;
          line-height: 20px;
          border: 1px solid #3b4e87;
          font-size: 12px;
          padding: 0 8px;
        }

        th {
          // background: #3b4e87;
          color: #011a45;
          font-weight: bold;
          text-align: center;
        }

        td {
          color: #000;
        }
      }
    }

    .payWrap {
      padding-top: 12px;
      font-size: 12px;

      .bankAccountWrap {
        .bankAccountItem {
          padding-top: 8px;

          p {
            line-height: 22px;

            label {
              font-weight: bold;
              margin-right: 4px;
            }

            span {
              color: #000;
              font-size: 12px;
            }
          }
        }
      }

      .qrcodeWrap {
        display: flex;
        gap: 16px;
        flex-wrap: wrap;
        padding-top: 16px;

        .qrcodeItem {
          text-align: center;

          img {
            max-width: 80px;
            max-height: 80px;
            display: block;
            margin: 0 auto 4px;
          }
        }
      }
    }
  }
}
</style>
